import { ref } from 'vue';
import { loanApi } from '@/apis/spot';

let timer = null;

export function useAssets(pledgeToken, accountType) {
    const transferBalance = ref('');

    const getTransferAsset = async () => {
        if (!pledgeToken) return;
        const res = await loanApi.getTransferAsset({
            token: pledgeToken,
            accountType,
        });
        if (res.success) {
            const { balance } = res.result;
            transferBalance.value = balance;
        }
    };

    // 预渲染逻辑
    if (!window.sfe.prerender) {
        clearInterval(timer);
        getTransferAsset();
    }

    timer = setInterval(() => {
        getTransferAsset();
    }, 5000);

    return {
        transferBalance,
    };
}

export const stopLoopAssets = () => {
    if (timer) {
        clearInterval(timer);
    }
};
